var core = module.exports = { version: '2.6.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



//////////////////
// WEBPACK FOOTER
// /code/frontend/~/core-js/modules/_core.js
// module id = ../../../../core-js/modules/_core.js
// module chunks = 0